module.exports = __webpack_public_path__ + "img/PlantosasFullpage.98054d36.png";